import React from 'react';
import PropTypes from 'prop-types';
import PageLayout from '../../componentsV2/PageLayout/PageLayout';
import Button from '../../componentsV2/Button/Button';

const EmailVerificationShowPage = ({ token, userFullName, newEmail }) => {
  return (
    <PageLayout
      pageTitle="Email Verification"
      shouldShowPageHeader
      shouldShowBreadcrumbs={false}
    >
      <div className="my-4 pl-2">
        <p className="text-lg mb-4">You are verifying the email address change for:</p>

        <div className="p-4 rounded mb-4 max-w-2xl">
          <p className="font-semibold">Account: {userFullName}</p>
        </div>

        <div className="p-4 rounded mb-6 max-w-2xl">
          <p className="font-semibold">
            New email address:
            <span className="text-vamos-blue ml-2">{newEmail}</span>
          </p>
        </div>

        <form action="/verify-email" method="post">
          <input type="hidden" name="_method" value="patch" />
          <input
            type="hidden"
            name="authenticity_token"
            value={document.querySelector('meta[name="csrf-token"]')?.content}
          />
          <input type="hidden" name="token" value={token} />

          <Button
            label="Confirm email change"
            type="submit"
            color="action"
            size="lg"
            className="min-w-64 mb-6"
            dataTestId="email-verification-confirm-button"
          />
        </form>

        <p className="text-sm text-vamos-gray">
          Make sure this is the correct account before confirming.
        </p>
      </div>
    </PageLayout>
  );
};

EmailVerificationShowPage.propTypes = {
  token: PropTypes.string.isRequired,
  userFullName: PropTypes.string.isRequired,
  newEmail: PropTypes.string.isRequired,
};

export default EmailVerificationShowPage;
